import styled from "styled-components";
import { shade } from "polished";

export const Container = styled.button`
  background-color: #ec0065;
  padding: 10px;
  width: 100%;
  margin-top: 10px;
  border-radius: 5px;
  border-style: none;
  color: #fff;
  font-weight: bold;
  transition: background-color 0.2s;

  &:hover {
    background: ${shade(0.2, "#00005f")};
  }
`;
